import React from 'react'
import Modal from '../../../../components/modal/modal'
import { saveInvoice } from '../../../../actions/invoice.action'
import { format } from 'date-fns'
import './invoices.scss'
import ViewInvoiceDiscription from 'src/components/view-invoice-description/view'
import idx from 'idx'
import { useDispatch } from 'react-redux'

function ViewInvoice(props) {

  const { open, dialogClose, invoiceData, filter, customerPaymentTerms, projectQuoteType, invoiceAndProgressClaim = [] } = props
  const dispatch = useDispatch();

  let progressClaimDueDate;

  // const progressClaimNo = filter === 'INVOICES' ? invoiceData.claimNumber : invoiceData.claimNumber
  const invoiceId = (invoiceData.invoice) ? (invoiceData.invoice.id) : (invoiceData.id)
  const issueDate = invoiceData.invoiceDate ? format(new Date(invoiceData.invoiceDate), 'dd/MM/yyyy') : ''
  const dueDateInvoice = invoiceData.dueDate ? format(new Date(invoiceData.dueDate), 'dd/MM/yyyy') : ''
  let invoiceDate = invoiceData.invoiceDate ? new Date(invoiceData.invoiceDate) : new Date()
  let dueDate = invoiceData.dueDate ? new Date(invoiceData.dueDate) : progressClaimDueDate


  if (filter === 'PROGRESS_CLAIM') {
    if (customerPaymentTerms) {
      progressClaimDueDate = new Date(invoiceDate);
      progressClaimDueDate.setDate(progressClaimDueDate.getDate() + customerPaymentTerms);
    }
  }

  const retentionAmount = filter === 'INVOICES' ? invoiceData.retentionAmount : invoiceData.retentionAmount
  const claimedRetention = filter === 'INVOICES' ? invoiceData.retentionClaimAmount : invoiceData.retentionClaimAmount
  let lessRetention = retentionAmount || 0
  let claimedRetentionEdit = claimedRetention || 0

  const generateInvoice = async () => {

    const data = {
      progressClaimId: invoiceData.u_id,
      dueDate,
      invoiceDate,
      retentionAmount: lessRetention,
      retentionClaimAmount: claimedRetentionEdit,
    }
    if (filter === 'PROGRESS_CLAIM') {
      const result = await dispatch(saveInvoice(data)).catch(e => console.error(e))
      props.handleDownloadDialog(result.u_id, 'INVOICE', 'PROGRESS_CLAIM')
    } else if (filter === 'PROGRESSCLAIM') {
      props.handleDownloadDialog(invoiceData.u_id, 'PROGRESSCLAIM')
    } else {
      props.handleDownloadDialog(invoiceData.u_id, 'INVOICE')
    }
    dialogClose()
  }

  const editProgressClaim = async () => {
    props.handleGeneratePC(invoiceData.u_id);
  }


  return (
    <Modal
      open={open}
      onClose={dialogClose}
      fullWidth={true}
      maxWidth='sm'
      modalHeading={filter === 'PROGRESS_CLAIM' ? 'Generate Invoice' : 'View Invoice'}
      modalSaveTxt={filter === 'PROGRESS_CLAIM' ? 'Save' : 'Download'}
      modalCloseTxt='Back'
      modalEditTxt={filter === 'PROGRESSCLAIM' ? 'Edit' : ''}
      onClick={generateInvoice}
      onEdit={editProgressClaim}
      showActionBtn
      savebtnClass='createBtn'
      cxlbtnClass='cancelBtn'
      primary
    >
      <>
        <div className="row">
          {/* <div className="col-lg-4 mt-3">
            <div className="view-block">
              <label>Progress Claim</label>
              <p className="mt-2"><b>{progressClaimNo}</b></p>
            </div>
          </div> */}
          <div className="col-lg-4 mt-3">
            <div className="view-block">
              <label>Invoice Number</label>
              <p className="mt-2"><b>{invoiceId}</b></p>
            </div>
          </div>
          <div className="col-lg-4 mt-3">
            <div className="view-block">
              <label>Invoice Date</label>
              <p className="mt-2">{issueDate}</p>
            </div>
          </div>
          <div className="col-lg-4 mt-3">
            <div className="view-block">
              <label>Due Date</label>
              <p className="mt-2">{dueDateInvoice}</p>
            </div>
          </div>
          {projectQuoteType == 'quote' && <div className="col-lg-4 mt-3">
            <div className="view-block">
              <label>Amount Retained</label>
              <p className="mt-2">{(retentionAmount)}</p>
            </div>
          </div>}
          {projectQuoteType == 'quote' && <div className="col-lg-4 mt-3">
            <div className="view-block">
              <label>Retention Claim</label>
              <p className="mt-2">{(claimedRetentionEdit)}</p>
            </div>
          </div>}
        </div>

        <ViewInvoiceDiscription
          invoiceData={idx(invoiceData, _ => _.progressClaim) || invoiceData}
          showClaimHistory={true}
          projectQuoteType={projectQuoteType}
          filter={filter}
          invoiceAndProgressClaim={invoiceAndProgressClaim}
        />
      </>
    </Modal >
  )
}

export default ViewInvoice;
